<script setup>
const props = defineProps({
  modelos: Array,
})
</script>

<template>
  <div class="container-models-rural">
    <h3>Modelos</h3>
      <div class="grid-products" >
        <div class="card" v-for="product in modelos.products">
          <a :href="product.slug">
            <div class="image-wrapper" v-if="product.dynamicGalleries && product.dynamicGalleries.length > 0">
              <img :src="product.dynamicGalleries[0].fullUrl" :alt="product.name" class="main-image">
              <div class="image-title">
                <p>{{ product.name }} {{product.reference}}</p>
                <p>{{product.label_list}}</p>
              </div>

            </div>
          </a>
        </div>
      </div>
    </div>
</template>
<style scoped>

</style>
